export default "__VITE_ASSET__d50969a7__"